const Iletisim = resolve => {
    require.ensure(['../views/apps/iletisim/Iletisim'], () => {
        resolve(require('../views/apps/iletisim/Iletisim'))
    })
};
const IletisimListesi = resolve => {
    require.ensure(['../views/apps/iletisim/IletisimListesi'], () => {
        resolve(require('../views/apps/iletisim/IletisimListesi'))
    })
};

import layouts from '../layout'
import Vue from 'vue'
Vue.component('Iletisim', IletisimListesi);

export default {
    path: '/iletisim',
    name: 'iletisim',
    component: Iletisim,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'liste',
            name: 'iletisimListesi',
            component: IletisimListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ],

}
